import { render, staticRenderFns } from "./ItemAdvice.vue?vue&type=template&id=4ad7215c&scoped=true&"
import script from "./ItemAdvice.vue?vue&type=script&lang=js&"
export * from "./ItemAdvice.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdvice.vue?vue&type=style&index=0&id=4ad7215c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7215c",
  null
  
)

export default component.exports